import React, { Component } from "react";
import { HashRouter as Router, Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Banner } from "../home/banner/index.jsx";
import { padZeros, getLocalTime, getFormattedDate, getParamValueFromURL } from "../utils.js";
import "./index.scss";
export class EditionDetails extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const event = this.props.config;
    document.title = "".concat(event.name, " ").concat(event.location);
  }

  render() {
    const event = this.props.config;
    const editionId = getParamValueFromURL("editionId") || 1;
    const editions = event.editions;
    const edition = editions.find(e => e.id === Number(editionId));
    if (!edition) return /*#__PURE__*/React.createElement("p", null, "Edition not found");
    const title = edition.title || "EDITION ".concat(edition.id, " ");
    const startTime = new Date(edition.startTime);
    const sessions = (edition === null || edition === void 0 ? void 0 : edition.sessions) || [];
    const talks = (sessions === null || sessions === void 0 ? void 0 : sessions.map(session => session.talks).flat()) || [];

    const renderEditionInfo = () => {
      return /*#__PURE__*/React.createElement("div", {
        className: "basicInfo"
      }, /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("p", {
        className: "date"
      }, "Edition ", edition.id, " | ", getFormattedDate(startTime)), /*#__PURE__*/React.createElement("p", {
        className: "title"
      }, title)), /*#__PURE__*/React.createElement("div", {
        className: "stats"
      }, sessions.length > 1 && /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("p", {
        className: "value"
      }, String(sessions.length).padStart(2, "0")), /*#__PURE__*/React.createElement("p", null, "Sessions")), /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("p", {
        className: "value"
      }, String(talks.length).padStart(2, "0")), /*#__PURE__*/React.createElement("p", null, talks.length > 1 ? "Talks" : "Talk"))));
    };

    const renderTalksInfo = () => {
      const renderSpeakerInfo = speakers => {
        const renderSpeaker = speaker => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
          className: "pic",
          src: speaker.profilePicture,
          alt: speaker.name,
          loading: "lazy"
        }), /*#__PURE__*/React.createElement("div", {
          className: "info"
        }, /*#__PURE__*/React.createElement("div", {
          className: "name"
        }, speaker.name), /*#__PURE__*/React.createElement("div", {
          className: "desgination"
        }, speaker.desgination)));

        if (speakers && speakers.length == 1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "speakerInfo"
          }, renderSpeaker(speakers[0]));
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "speakers"
        }, speakers && speakers.map((speaker, index) => /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "speaker"
        }, renderSpeaker(speaker))));
      };

      return /*#__PURE__*/React.createElement("div", {
        className: "talks"
      }, talks && talks.map((talk, index) => /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "talk"
      }, /*#__PURE__*/React.createElement("div", {
        className: "talkInfo"
      }, /*#__PURE__*/React.createElement("span", {
        className: "talk-title"
      }, /*#__PURE__*/React.createElement("span", {
        className: "bold"
      }, padZeros(index + 1, 2)), /*#__PURE__*/React.createElement("span", {
        className: "light"
      }, "/", padZeros(talks.length, 2), " "), /*#__PURE__*/React.createElement("span", {
        className: "bold"
      }, talk.title)), /*#__PURE__*/React.createElement("div", {
        className: "timeSlot light"
      }, talk.startTime && getLocalTime(new Date(talk.startTime)), talk.startTime && talk.endTime && " - ".concat(getLocalTime(new Date(talk.endTime)))), /*#__PURE__*/React.createElement("div", {
        className: "description"
      }, talk.description), talk.speakers && renderSpeakerInfo(talk.speakers), talk.recording && talk.slides && /*#__PURE__*/React.createElement("div", {
        className: "button-wrapper"
      }, /*#__PURE__*/React.createElement("a", {
        className: "slides",
        target: "_blank",
        rel: "noreferrer",
        href: talk.slides
      }, "View presentation"))), (talk.recording || talk.slides) && /*#__PURE__*/React.createElement("iframe", {
        src: talk.recording ? talk.recording : talk.slides,
        width: "560",
        height: "315",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true,
        mozallowfullscreen: "true",
        webkitallowfullscreen: "true"
      }))));
    };

    return /*#__PURE__*/React.createElement("div", {
      id: "event-home",
      className: "event-home"
    }, /*#__PURE__*/React.createElement(Banner, {
      event: event,
      small: true
    }), /*#__PURE__*/React.createElement("div", {
      className: "view-all"
    }, /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(Link, {
      to: "./list"
    }, "< Back to all editions"))), /*#__PURE__*/React.createElement("div", {
      className: "editionDetails"
    }, renderEditionInfo(), renderTalksInfo()), /*#__PURE__*/React.createElement("p", {
      className: "copyright"
    }, "\xA9 2021 Thoughtworks, Inc."));
  }

}
EditionDetails.propTypes = {
  config: PropTypes.object.isRequired,
  location: PropTypes.object
};